module.exports = __webpack_public_path__ + "img/service6.6943bbb6.svg";